import React, { useEffect, useMemo, useState } from 'react';
import store from 'store';
import { Button, Badge } from 'reactstrap';
import { useSelector } from 'react-redux';

import { MdPhoneForwarded } from 'react-icons/md';
import { removeConversationInAttendance } from 'store/action/conversation-in-attendance-action';
import { AiFillWarning } from 'react-icons/ai';

import {
  MessageReceived,
  MessageCount,
  TagBody,
  TagStyle,
  ClientName,
  LeftZone,
  RightZone,
  QueueName,
  ChannelName,
  TimeZone
} from '../styled';
import { getProps, getTime } from './assets';
import { TagChatClient } from 'components/TagChatClient';
import { IconsChannel } from 'components/IconsChannel/IconsChannel';
import { formatTime } from './utils';

const QueueTag = ({
  conversation = {},
  allQueues = [],
  functionAnswerConversation,
  idNameTags = {}
}) => {
  // eslint-disable-next-line no-unused-vars
  const [iconName, setIconName] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [queueColor, setQueueColor] = useState('');
  const [countTags, setCountTags] = useState(0);
  const [newMessagesCount, setNewMessagesCount] = useState(0);
  const [tagProps, setTagProps] = useState({});
  const [time, setTime] = useState('00:00:00');
  const [timeSeconds, setTimeSeconds] = useState('00:00:00');
  const [lastClientMessageTime, setLastClientMessageTime] = useState(null);
  const [waitingTime, setWaitingTime] = useState(null);
  const conversationInAttendance = useSelector(
    (state) => state.conversationInAttendance
  );

  const formattedTime = useMemo(() => formatTime(time), [time]);

  //setting timer
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(getTime(conversation.dateOfLastAction));
    }, 1000);
    return () => clearInterval(timer);
  }, [conversation]);

  //New messages
  useEffect(() => {
    conversation.novas_mensagens > 99
      ? setNewMessagesCount('+99')
      : setNewMessagesCount(conversation.novas_mensagens);

    setCountTags(conversation?.tags?.length || 0);

    const clientMessages = conversation.mensagens
      .filter((msg) => msg.cliente_ou_atendente === 'cliente')
      .sort(
        (a, b) => new Date(a.hora_da_mensagem) - new Date(b.hora_da_mensagem)
      );

    const attendantMessages = conversation?.mensagens
      .filter((msg) => msg?.cliente_ou_atendente === 'atendente')
      .sort(
        (a, b) => new Date(a.hora_da_mensagem) - new Date(b.hora_da_mensagem)
      );

    const lastAttendantMessage =
      attendantMessages.length > 0
        ? attendantMessages[attendantMessages.length - 1]
        : null;

    let firstClientMessageAfterAttendant = null;
    for (let i = 0; i < clientMessages?.length; i++) {
      const msg = clientMessages[i];
      if (
        lastAttendantMessage &&
        new Date(msg.hora_da_mensagem) >
          new Date(lastAttendantMessage.hora_da_mensagem)
      ) {
        firstClientMessageAfterAttendant = msg;
        break;
      }
    }
    if (firstClientMessageAfterAttendant) {
      const lastClientMessage = firstClientMessageAfterAttendant;
      setLastClientMessageTime(new Date(lastClientMessage.hora_da_mensagem));
      const calculateWaitingTime = () => {
        const now = new Date();
        const timeDiff = now - new Date(lastClientMessage.hora_da_mensagem);
        const seconds = Math.floor((timeDiff / 1000) % 60);
        const totalSeconds = Math.floor(timeDiff / 1000);
        const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
        const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
        setWaitingTime(`${hours}h ${minutes}m ${seconds}s`);
        setTimeSeconds(totalSeconds);
      };
      calculateWaitingTime();
      let interval = setInterval(calculateWaitingTime, 1000);
      return () => clearInterval(interval);
    } else {
      setWaitingTime('00:00:00');
      setTimeSeconds('00:00:00');
    }
  }, [conversation]);

  //getting tag data
  useEffect(() => {
    let copyConversation = { ...conversation };
    if (!conversation._id && conversation.id) {
      copyConversation._id = copyConversation.id;
    }
    if (
      !!conversationInAttendance &&
      conversationInAttendance?.conversation?._id === copyConversation?._id
    ) {
      setTagProps(getProps('atendida'));
    } else {
      setTagProps(getProps(copyConversation.situacao));
    }

    //getting queue color
    allQueues.forEach((el) => {
      copyConversation.fila === el.name && setQueueColor(el.color);
    });

    if (copyConversation?.cliente?.nome) {
      let nameArray = copyConversation?.cliente?.nome.split(' ');
      let initials = '';

      for (let i = 0; i < nameArray.length; i++) {
        if (nameArray[i][0]) initials = initials.concat(nameArray[i][0]);
        if (i === 1) break;
      }

      setIconName(initials);
    } else {
      setIconName('I');
    }
  }, [conversation, allQueues, conversationInAttendance]);

  //aswering conversation
  const answerConversation = async () => {
    await store.dispatch(removeConversationInAttendance());
    functionAnswerConversation(
      conversation._id ?? conversation.id,
      conversation.meioTransferencia,
      //telephonyServicePanel,
      conversation.cliente.telefone,
      conversation.canal
    );
  };

  const answerConversationToast = async (id) => {
    await store.dispatch(removeConversationInAttendance());
    functionAnswerConversation(
      id,
      '',
      //telephonyServicePanel,
      '',
      ''
    );
  };

  const getChannelIcon = (channel, transferMode) => {
    if (transferMode === 'call') {
      return <MdPhoneForwarded size="20" color="#d9534f" />;
    } else {
      return <IconsChannel channel={channel} showName={false} />;
    }
  };

  return conversation ? (
    <Button
      className="mb-3"
      style={TagStyle(queueColor)}
      onClick={answerConversation}
      title={`Cliente: ${conversation?.cliente?.nome} \nFila: ${
        conversation.fila
      }\nCanal: ${conversation?.canal}\nMeio de transferência: ${
        conversation.meioTransferencia === 'call'
          ? 'Ligação\nRealize o login em algum ramal para continuar o atendimento!'
          : 'Chat'
      }`}
    >
      <TagBody>
        <LeftZone>
          <ClientName className="mt--2">
            {conversation?.cliente?.nome}
          </ClientName>
          <QueueName className="mt--2 text-muted">
            Fila: {conversation.fila}
          </QueueName>
          <ChannelName className="mt--2 text-muted">
            {getChannelIcon(
              conversation?.canal,
              conversation?.meioTransferencia
            )}
          </ChannelName>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            {conversation?.tags && countTags > 2 ? (
              <>
                <TagChatClient
                  name={idNameTags[conversation.tags[0]]?.name}
                  color={idNameTags[conversation.tags[0]]?.color || '#5086c1'}
                  disabled={idNameTags[conversation.tags[0]]?.disabled}
                />
                <TagChatClient
                  name={idNameTags[conversation.tags[2]]?.name}
                  color={idNameTags[conversation.tags[2]]?.color || '#5086c1'}
                  disabled={idNameTags[conversation.tags[1]]?.disabled}
                />
                <TagChatClient
                  name={`+${countTags - 2}`}
                  allTags={conversation?.tags}
                  idNameTags={idNameTags}
                  isMore={true}
                  color="#5086c1"
                  index={conversation?.id}
                />
              </>
            ) : (
              <>
                {Object.keys(idNameTags).length > 0 &&
                  conversation?.tags &&
                  conversation?.tags?.map((tag, index) => (
                    <TagChatClient
                      key={index}
                      name={idNameTags[tag]?.name}
                      color={idNameTags[tag]?.color || '#5086c1'}
                      disabled={idNameTags[tag]?.disabled}
                    />
                  ))}
              </>
            )}
          </div>
        </LeftZone>
        <RightZone>
          <TimeZone className="mt--2">{formattedTime}</TimeZone>
          <h4 className="mt--2">
            <Badge color={tagProps?.badge}>{tagProps?.status}</Badge>
          </h4>
          <MessageReceived>
            <div style={{ display: 'flex' }}>
              {newMessagesCount > 0 && (
                <MessageCount> {newMessagesCount} </MessageCount>
              )}
            </div>

            <div style={{ display: 'flex', marginLeft: '-2px' }}>
              {timeSeconds > 180 &&
                timeSeconds < 300 &&
                conversation?.situacao === 'em_atendimento' && (
                  <span title="O tempo de espera é estável, variando entre 3 e 5 minutos">
                    <AiFillWarning size="22" color="#FFC222" />
                  </span>
                )}

              {timeSeconds > 0 &&
                timeSeconds > 300 &&
                conversation?.situacao === 'em_atendimento' && (
                  <span title="Tempo de espera é crítico, passando de 5 minutos">
                    <AiFillWarning size="22" color="#C13617" />
                  </span>
                )}
            </div>
          </MessageReceived>
        </RightZone>
      </TagBody>
    </Button>
  ) : null;
};

export default QueueTag;
